import { application } from '../axios.service'

export const ServiceNotification = {
    send: (data) => application.post('/notification/send', data),
}
